import { createStore } from 'vuex'

export default createStore({
    state: {
        app_name: null,
        // 初期データ
        user_id: null,
        is_root: null,
        file_upload: null,
        is_debug: null,
        user: null,
        max_filesize: 10,
    },
    mutations : {
        setAppName(state, app_name) { state.app_name = app_name; },
        setUserId(state, id) {state.user_id = id;},
        setIsRoot(state, is_root) {state.is_root = is_root;},
        setFileUpload(state, file_upload) {state.file_upload = file_upload;},
        setIsDebug(state, is_debug) {state.is_debug = is_debug;},
        setUser(state, user) {state.user = user;},
        setMaxFilesize(state, max_filesize) {state.max_filesize = max_filesize;},
    },
    getters: {
        appName(state) { return state.app_name; },
        userId(state) { return state.user_id; },
        isRoot(state) { return state.isRoot; },
        fileUpload(state) { return state.file_upload; },
        isDebug(state) { return state.isDebug; },
        user(state) { return state.user; },
    }
});
